import { useEffect, useState } from 'react';
import { DEFAULT_LANGUAGE, LanguageCode } from '@models';
import { config } from '@config';

export const useBrowserLanguage = (): Maybe<LanguageCode> => {
	const [language, setLanguage] = useState<Maybe<LanguageCode>>(
		Object.values(LanguageCode).includes(config.lang as LanguageCode) ? (config.lang as LanguageCode) : DEFAULT_LANGUAGE.code
	);

	useEffect(() => {
		const parts = (navigator.language || '').replace(/[-_]/gi, '@').split('@').map(part => part.toLowerCase());
		const codes = Object.values(LanguageCode);
		const foundLang = parts.find(part => codes.includes(part as LanguageCode));
		setLanguage((foundLang || DEFAULT_LANGUAGE.code) as LanguageCode);
	}, []);

	return language;
};
